
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Modern Family Home',
      category: 'construction',
      image: 'https://public.readdy.ai/ai/img_res/9e6b9559a823b2532a925e82de11d583.jpg',
      description: 'Custom 3,500 sq ft family home with modern amenities',
      location: 'Oakville, ON',
      year: '2024'
    },
    {
      id: 2,
      title: 'Backyard Paradise',
      category: 'landscape',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20backyard%20landscape%20design%20with%20lush%20green%20grass%2C%20garden%20features%2C%20outdoor%20living%20space%2C%20professional%20landscaping%2C%20backyard%20transformation&width=400&height=300&seq=23&orientation=landscape',
      description: 'Complete backyard transformation with pool and garden',
      location: 'Burlington, ON',
      year: '2024'
    },
    {
      id: 3,
      title: 'Commercial Office Building',
      category: 'construction',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20office%20building%20with%20red%20brick%20facade%2C%20business%20architecture%2C%20professional%20construction%2C%20urban%20development%2C%20commercial%20real%20estate&width=400&height=300&seq=24&orientation=landscape',
      description: '15,000 sq ft office complex with parking facility',
      location: 'Toronto, ON',
      year: '2023'
    },
    {
      id: 4,
      title: 'Front Yard Renovation',
      category: 'landscape',
      image: 'https://readdy.ai/api/search-image?query=Front%20yard%20landscape%20renovation%2C%20curb%20appeal%20improvement%2C%20beautiful%20front%20garden%2C%20professional%20landscaping%2C%20home%20exterior%20enhancement&width=400&height=300&seq=25&orientation=landscape',
      description: 'Enhanced curb appeal with new plantings and walkway',
      location: 'Mississauga, ON',
      year: '2024'
    },
    {
      id: 5,
      title: 'Heritage Home Restoration',
      category: 'construction',
      image: 'https://readdy.ai/api/search-image?query=Heritage%20home%20restoration%20with%20red%20brick%2C%20historical%20building%20renovation%2C%20classic%20architecture%2C%20restoration%20project%2C%20traditional%20construction&width=400&height=300&seq=26&orientation=landscape',
      description: 'Careful restoration of 1920s heritage home',
      location: 'Hamilton, ON',
      year: '2023'
    },
    {
      id: 6,
      title: 'Corporate Headquarters Garden',
      category: 'landscape',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20headquarters%20garden%20design%2C%20commercial%20landscaping%2C%20business%20property%20landscape%2C%20professional%20outdoor%20space%2C%20office%20building%20grounds&width=400&height=300&seq=27&orientation=landscape',
      description: 'Sophisticated landscaping for corporate headquarters',
      location: 'Markham, ON',
      year: '2023'
    },
    {
      id: 7,
      title: 'Luxury Home Addition',
      category: 'construction',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20home%20addition%20construction%2C%20house%20extension%2C%20residential%20renovation%2C%20home%20improvement%2C%20quality%20construction%20work%2C%20architectural%20addition&width=400&height=300&seq=28&orientation=landscape',
      description: 'Two-story addition with master suite and family room',
      location: 'Richmond Hill, ON',
      year: '2024'
    },
    {
      id: 8,
      title: 'Rooftop Garden Oasis',
      category: 'landscape',
      image: 'https://readdy.ai/api/search-image?query=Rooftop%20garden%20oasis%20design%2C%20urban%20landscaping%2C%20rooftop%20terrace%2C%20green%20roof%2C%20city%20garden%2C%20outdoor%20living%20space%2C%20urban%20landscape%20architecture&width=400&height=300&seq=29&orientation=landscape',
      description: 'Urban rooftop garden with seating and water features',
      location: 'Toronto, ON',
      year: '2024'
    }
  ];

  const filters = [
    { id: 'all', label: 'All Projects' },
    { id: 'construction', label: 'Construction' },
    { id: 'landscape', label: 'Landscape' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Our Portfolio</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our completed projects and see the quality craftsmanship that sets us apart
          </p>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center space-x-4">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeFilter === filter.id
                    ? 'bg-red-700 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div key={project.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 object-cover object-top"
                  />
                  <div className="absolute top-4 left-4">
                    <span className={`inline-block px-3 py-1 text-sm font-medium text-white rounded-full ${
                      project.category === 'construction' ? 'bg-red-700' : 'bg-green-600'
                    }`}>
                      {project.category === 'construction' ? 'Construction' : 'Landscape'}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                  <p className="text-gray-600 mb-4">{project.description}</p>
                  <div className="flex justify-between items-center text-sm text-gray-500">
                    <span className="flex items-center">
                      <i className="ri-map-pin-line mr-1"></i>
                      {project.location}
                    </span>
                    <span className="flex items-center">
                      <i className="ri-calendar-line mr-1"></i>
                      {project.year}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-red-700 mb-2">500+</div>
              <div className="text-gray-600">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-700 mb-2">25+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-700 mb-2">98%</div>
              <div className="text-gray-600">Client Satisfaction</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-700 mb-2">50+</div>
              <div className="text-gray-600">Team Members</div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Testimonials */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
            <p className="text-xl text-gray-600">Real feedback from satisfied customers</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                "The team at BrickGreen exceeded our expectations. Our new home is everything we dreamed of and more."
              </p>
              <div className="flex items-center">
                <img 
                  src="https://readdy.ai/api/search-image?query=Happy%20professional%20woman%20client%20smiling%2C%20satisfied%20customer%20testimonial%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire&width=60&height=60&seq=30&orientation=squarish"
                  alt="Jennifer Smith"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">Jennifer Smith</h4>
                  <p className="text-sm text-gray-600">Homeowner</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                "Professional, reliable, and the quality of work is outstanding. Our landscape is now the envy of the neighborhood."
              </p>
              <div className="flex items-center">
                <img 
                  src="https://readdy.ai/api/search-image?query=Happy%20professional%20man%20client%20smiling%2C%20satisfied%20customer%20testimonial%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire&width=60&height=60&seq=31&orientation=squarish"
                  alt="David Wilson"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">David Wilson</h4>
                  <p className="text-sm text-gray-600">Business Owner</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                "From start to finish, the process was smooth and professional. We couldn't be happier with the results."
              </p>
              <div className="flex items-center">
                <img 
                  src="https://readdy.ai/api/search-image?query=Happy%20professional%20woman%20client%20smiling%2C%20satisfied%20customer%20testimonial%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire&width=60&height=60&seq=32&orientation=squarish"
                  alt="Maria Garcia"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">Maria Garcia</h4>
                  <p className="text-sm text-gray-600">Property Manager</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
